import { useNavigate } from "react-router";
import Icon from "../Icon/Icon.jsx";
import styles from "./backButton.css.ts";

/**
 * Renders a close button wrapped in a link.
 * The parent element sets the color of the button.
 *
 * @param {string} back - The path to navigate to when the button is clicked. For default, we got back on step in history stack of the web browser.
 * @param {string} ariaLabel - Description about what this button does; for screen readers
 * @param {string} theme - The color theme of the button
 * @param {boolean} replaceLink - If true, the browser history will be replaced with the new path
 * @returns {JSX.Element} A link component containing an icon button with a "close" icon.
 */
export function BackButton({
  backPath = -1,
  ariaLabel = "Zurück",
  theme = "light",
  replaceLink = false,
}) {
  const navigate = useNavigate();

  return (
    <button
      aria-label={ariaLabel}
      id={"close-button"}
      className={styles.containerButton({ theme: theme })}
      onClick={() => navigate(backPath, { replace: replaceLink })}
    >
      <Icon name={"arrowleft"} size={"16px"} />
    </button>
  );
}
